import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ah-status-pill',
    templateUrl: './status-pill.component.html',
    styleUrls: ['./status-pill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatusPillComponent {
    @Input() statusDisplay: string;
    @Input() statusColor: string;

    constructor() { }
}
